import {
  AccordionDetails as MuiAccordionDetails,
  Typography,
  Checkbox,
  Box,
  useTheme,
} from '@mui/material'
import { FormControlLabel } from 'Features/OperationalPlanner/WorkcentreModal/FormControlLabel/FormControlLabel.view'
import { AccordionDetailsProps } from './AccordionDetails.types'

export const AccordionDetails = ({
  sourceSiteData,
  handleCheckboxChange,
  readOnly,
}: AccordionDetailsProps) => {
  const theme = useTheme()

  return (
    <MuiAccordionDetails
      id={sourceSiteData.siteLabel}
      sx={{
        padding: '0px',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {sourceSiteData.siteWorkcentres.map((worcentre) =>
        readOnly ? (
          worcentre.isSelected ? (
            <Box
              key={worcentre.key}
              sx={{
                display: 'flex',
                alignItems: 'center',
                borderBottom: `1px solid ${theme.palette.grey[300]}`,
                padding: '0px 32px',
                minHeight: '48px',
              }}
            >
              <Typography>{worcentre.code}</Typography>
            </Box>
          ) : null
        ) : (
          <Box
            key={worcentre.key}
            sx={{
              display: 'flex',
              alignItems: 'center',
              borderBottom: `1px solid ${theme.palette.grey[300]}`,
              padding: '0px 32px',
              minHeight: '48px',
            }}
          >
            <FormControlLabel
              label={worcentre.code}
              control={
                <Checkbox
                  disabled={worcentre.productCount === 0}
                  color="primary"
                  sx={{
                    color: theme.palette.primary.main,
                  }}
                  checked={worcentre.isSelected}
                  onChange={(event) =>
                    handleCheckboxChange(
                      event,
                      sourceSiteData.siteLabel,
                      worcentre.code
                    )
                  }
                />
              }
            />
          </Box>
        )
      )}
    </MuiAccordionDetails>
  )
}
